module.exports = __webpack_public_path__ + "img/produccion.4c5db839.png";